import React, { useState } from 'react';
interface FAQItem {
  question: string;
  answer: string;
}
const faqs: FAQItem[] = [{
  question: '1 — ¿Cómo recibo el MegaPack después de comprar?',
  answer: 'Inmediatamente después de acreditado el pago, recibís un email con el enlace de descarga de todos los PDFs. El acceso es instantáneo.'
}, {
  question: '2 — ¿Sirve para mi provincia o solo para Buenos Aires?',
  answer: 'Sirve para todo el país. El material está alineado al Currículo Escolar Argentino vigente a nivel nacional.'
}, {
  question: '3 — ¿Los 6 bonos están en las dos ofertas?',
  answer: 'Sí. Los 6 bonos estratégicos están incluidos en ambas ofertas sin costo adicional.'
}, {
  question: '4 — ¿Sirve si soy docente nuevo o con poca experiencia?',
  answer: 'Es perfecto para docentes nuevos porque cada tomo tiene la planificación anual ya hecha, las secuencias didácticas paso a paso y el solucionario completo.'
}, {
  question: '5 — ¿Qué diferencia tiene el MegaPack con otros materiales que vi en internet?',
  answer: 'Material de internet: suelto, sin secuencia, Português de Portugal, sin solucionario.\n\nMegaPack: sistema completo, 100% Português Brasileiro, solucionario completo, planificación anual lista.'
}, {
  question: '6 — ¿Tiene garantía real?',
  answer: 'Real, incondicional y sin letra chica. 7 días para revisar, usar en el aula y decidir. Si no es lo que esperabas, te devolvemos el 100% del precio sin preguntas.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-[#0a0a0a] py-16 px-4" data-id="element-136">
      <div className="max-w-3xl mx-auto" data-id="element-137">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-10" data-id="element-138">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-3 mb-10" data-id="element-139">
          {faqs.map((faq, i) => <div key={i} className={`rounded-xl border transition-colors ${openIndex === i ? 'border-[#39FF14] bg-[#000d08]' : 'border-[#39FF14]/20 bg-black'}`} data-id="element-140">
              <button className="w-full text-left px-5 py-4 flex items-center justify-between gap-3" onClick={() => setOpenIndex(openIndex === i ? null : i)} aria-expanded={openIndex === i} data-id="element-141">
                <span className="text-white font-bold text-sm sm:text-base" data-id="element-142">
                  ❓ {faq.question}
                </span>
                <span className={`text-[#39FF14] text-xl flex-shrink-0 transition-transform ${openIndex === i ? 'rotate-45' : ''}`} data-id="element-143">
                  +
                </span>
              </button>
              {openIndex === i && <div className="px-5 pb-5" data-id="element-144">
                  <div className="h-px bg-[#39FF14]/20 mb-4" data-id="element-145" />
                  {faq.answer.split('\n\n').map((para, j) => <p key={j} className="text-gray-200 text-sm leading-relaxed mb-3 last:mb-0" data-id="element-146">
                      {para}
                    </p>)}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}